var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgYes = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9984 21.5999C17.3004 21.5999 21.5984 17.3018 21.5984 11.9999C21.5984 6.69797 17.3004 2.3999 11.9984 2.3999C6.6965 2.3999 2.39844 6.69797 2.39844 11.9999C2.39844 17.3018 6.6965 21.5999 11.9984 21.5999Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7413 15.8283C10.6343 15.8284 10.5284 15.8071 10.4297 15.7658C10.331 15.7245 10.2416 15.6639 10.1666 15.5877L7.19185 12.5656C7.04197 12.4128 6.95893 12.2068 6.96097 11.9928C6.96301 11.7788 7.04997 11.5743 7.20273 11.4245C7.3555 11.2746 7.56154 11.1915 7.77554 11.1936C7.98955 11.1956 8.19399 11.2826 8.34387 11.4353L10.7157 13.8494L15.6322 8.43502C15.7779 8.2845 15.9764 8.19658 16.1858 8.18987C16.3952 8.18316 16.5989 8.25818 16.754 8.39907C16.909 8.53996 17.0031 8.73565 17.0164 8.94471C17.0297 9.15377 16.9611 9.35981 16.8251 9.51918L11.3365 15.5646C11.2629 15.6459 11.1736 15.7113 11.0739 15.7568C10.9742 15.8024 10.8662 15.8271 10.7567 15.8296L10.7413 15.8283Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgYes, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/yes.72a1fe54.svg";
export { ForwardRef as ReactComponent };